<template>
  <div class="swiper-item-container">
    <div class="swiper-outer" :class="{'swiper-outer-2': isSmall}">
      <svg-icon :icon-class="isSmall ? 'playDetails_498_370_border' : 'playDetails_716_394_border'" class-name="border-svg" />
      <div class="swiper-padding">
        <div class="img-wrap">
          <img :src="info.img" alt="">
        </div>
      </div>
    </div>
    <div v-if="info.smallImg" class="swiper-outer swiper-outer-small">
      <svg-icon icon-class="playDetails_470_260_border" class-name="border-svg" />
      <div class="swiper-padding">
        <div class="img-wrap">
          <img :src="info.smallImg" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {

    };
  },
  props: {
    info: {
      type: Object,
      default: () => { }
    },
    isSmall: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  watch: {},
  beforeDestroy() { },
  mounted() { },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>